import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { ModuleType } from 'app/library/module/enums/moduleType.enum';
import { Module } from 'app/library/module/models/module.model';

@Pipe({
    name: 'getModuleKindLabel',
})
@Injectable()
export class GetModuleKindLabelPipe implements PipeTransform {
    moduleKind = ModuleKind;

    transform(module: Module): string {
        switch (module.type) {
            case ModuleType.Basic:
            case ModuleType.Private:
                if (module.kind === this.moduleKind.ProgramExecution || module.kind === this.moduleKind.ProgramTemplate) {
                    return 'MODULE.TYPE.PROGRAM';
                } else if (module.selfPaced) {
                    return 'MODULE.TYPE.E-LEARNING';
                } else {
                    return 'MODULE.SINGULAR';
                }
            case ModuleType.ELearning:
                return 'MODULE.TYPE.E-LEARNING';
            default:
                return '';
        }
    }
}
